import { Button, Flex, Spacer, Text } from "@repo/ui";
import { useStyles } from "purse-styles";
import { useTheme } from "@repo/ui";
import { Dialog, Modal } from "react-aria-components";

type ConfirmDialogProps = {
	isOpen: boolean;
	title: string;
	message: string;
	confirmLabel: string;
	onConfirm: () => void;
	onCancel: () => void;
};

export function ConfirmDialog({
	isOpen,
	title,
	message,
	confirmLabel,
	onConfirm,
	onCancel,
}: ConfirmDialogProps) {
	const theme = useTheme();

	const modalClassName = useStyles({
		position: "fixed",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		zIndex: 1001,
	});

	const dialogClassName = useStyles({
		backgroundColor: theme.colors.sand1,
		border: `1px solid ${theme.colors.sand6}`,
		borderRadius: theme.borderRadiuses.md,
		padding: theme.spacing.md,
		minWidth: "320px",
		maxWidth: "400px",
		boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
		outline: "none",
	});

	if (!isOpen) return null;

	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={(open) => !open && onCancel()}
			className={modalClassName}
		>
			<Dialog className={dialogClassName}>
				<Flex column gap="lg">
					<Text size="lg" weight="semibold">
						{title}
					</Text>
					<Text size="md" color="sand11">
						{message}
					</Text>
					<Spacer height="sm" />
					<Flex gap="md" justify="flex-end">
						<Button variant="outline" onPress={onCancel}>
							Cancel
						</Button>
						<Button
							variant="primary"
							onPress={onConfirm}
							style={{
								background: theme.colors.red9,
							}}
						>
							{confirmLabel}
						</Button>
					</Flex>
				</Flex>
			</Dialog>
		</Modal>
	);
}
